
export  default {
    changeAccount:({commit},val )=>{
        commit('validator',val);
    },
    changeUserInfo:({commit}, val)=>{
        commit('setUserInfo', val);
    },
    changeCompanyInfo:({commit}, val)=>{
        commit('setCompanyInfo', val);
    },
    changeTeethInfo:({commit}, val)=>{
        commit('setTeethInfo', val);
    },
    // 清理登录信息 但保留记住的帐号密码
  clearLoginInfo() {
    // let userInfo = localStorage.userInfo; //保存登录的账号密码
    // let remember = localStorage.remember;
    localStorage.removeItem('userData')
    localStorage.removeItem('is_admin')
    localStorage.removeItem('token')
    localStorage.removeItem('managerId')
    // localStorage.clear();
    // localStorage.userInfo = userInfo;
    // localStorage.remember = remember;
  },
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js